function Header({onClickWelcome, onClickCourses, onClickLogin, onClickLogout, emailUser, verificationCode}) {
    let loginLogoutButton = <button type="button" className="btn btn-outline-primary" onClick={onClickLogin}>
        <i className="bi bi-box-arrow-in-right"></i> Login
    </button>;

    let listItemCourses = "";

    if (emailUser!=="" && emailUser!==null && verificationCode!=="" && verificationCode!==null) {
        loginLogoutButton = <button type="button" className="btn btn-outline-primary" onClick={onClickLogout}>
            <i className="bi bi-box-arrow-in-left"></i> Logout
        </button>

        listItemCourses = <li key="nav-item-to-courses" className="nav-item" style={{marginLeft: '1rem'}}>
            <button type="button" className="btn btn-outline-primary" onClick={onClickCourses}>
                <i className="bi bi-justify"></i> Zu den Kursen
            </button>
        </li>;
    }

    return (
        <div className="container">
            <header className="d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom">
                <a href="/#"
                   className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none"
                   onClick={onClickWelcome}>
                    <img height={"40"} width={"auto"} aria-hidden="true" src="/quizandpass_logo_horizontal.png"
                         alt="quiz and pass"/>
                </a>

                <ul className="nav nav-pills">

                    {listItemCourses}

                    <li key="nav-item-login-logout" className="nav-item" style={{marginLeft: '1rem'}}>
                        {loginLogoutButton}
                    </li>
                </ul>

            </header>
        </div>
    );
}

export default Header;